module.exports = __webpack_public_path__ + "74787a65f575e2ace4271841f1d91043.png";